import { DataManager, Query, WebApiAdaptor } from '@syncfusion/ej2-data';
import {
  CheckBoxComponent,
  ChipDirective,
  ChipListComponent,
  ChipsDirective,
} from '@syncfusion/ej2-react-buttons';
import {
  ChangeEventArgs,
  DropDownListComponent,
} from '@syncfusion/ej2-react-dropdowns';
import { getObject } from '@syncfusion/ej2-react-grids';
import { NumericTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import {
  Edit,
  Inject,
  TreeGridComponent,
  Toolbar,
  Filter,
  Page,
  ColumnChooser,
  ExcelExport,
  ColumnMenu,
  Resize,
  Sort,
  Reorder,
  Aggregate,
  ContextMenu,
  ColumnsDirective,
  ColumnDirective,
  FilterSettingsModel,
  PageSettingsModel,
} from '@syncfusion/ej2-react-treegrid';

import { useContext, useEffect, useState } from 'react';
import { FcSettings } from 'react-icons/fc';
import App1 from '../App';
import { ThemeContext } from '../context/theme.context';
import { GetBackendUrlForGlobalFunctions } from '../App';
import Cookies from "js-cookie";
var theGrid: TreeGridComponent = new TreeGridComponent({});
var current_index: number = -1;
interface IProps {
  columns: Array<any>;
  toolbarOptions?: any;
  height: string;
  get_query?: string;
  id?: string;
  isFitInCOntent?: boolean;
  rowSelected?: (args: any) => void;
  rowDeselected?: Function;
  enablePagination?: boolean;
  contextMenuItems?: Array<any>;
  contextMenuClick?: (args: any) => void;
  gridHierRef?: (component: TreeGridComponent) => void;
  hasChildMapping: string;
  idMapping: string;
  parentIdMapping: string;
  filterSettings: FilterSettingsModel;
  width?: string;
  dataSource?: DataManager;
  enableTreeSettings: boolean;
}
var sizemodeObj: DropDownListComponent;
var pageSizeObj: NumericTextBoxComponent;
var pageCountObj: NumericTextBoxComponent;
var currentPageObj: NumericTextBoxComponent;
const GlobalHierGrid = ({
  columns,
  toolbarOptions,
  height,
  get_query,
  id,
  isFitInCOntent,
  rowSelected,
  rowDeselected,
  enablePagination,
  contextMenuClick,
  contextMenuItems,
  gridHierRef,
  hasChildMapping,
  parentIdMapping,
  idMapping,
  filterSettings,
  width,
  enableTreeSettings,
}: IProps) => {
  const context = useContext(ThemeContext);
  const [settingsDialog, setSettingsDialog] = useState(false);
  const token = Cookies.get('token');
  useEffect(() => {
    var data: DataManager = new DataManager({
      adaptor: new WebApiAdaptor(),
      crossDomain: true,
      url: GetBackendUrlForGlobalFunctions() + `${get_query}`,
      headers: [{
        Authorization: `Bearer ${token}`,
        contentType: 'application/json',
      }],
    });
    theGrid.dataSource = data;
    theGrid.refresh();
  }, [get_query]);

  const pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 50,
    pageCount: 8,
    pageSizes: false,
  };
  const toolbarClick = (args: any) => {
    if (args.item.id === 'refresh') {
      // getData(query, model);
    }
  };
  const onGridCreated = () => {
    if (gridHierRef) {
      gridHierRef(theGrid);
    }
  };
  const onRowSelected = (args: any) => {
    current_index = args?.rowIndex;
    if (args.isInteracted) {
      if (rowSelected) {
        rowSelected(args);
      }
    }
  };
  var buttonSettingsDialog: ButtonPropsModel[] = [
    {
      click: () => {
        setSettingsDialog(false);
      },
      buttonModel: {
        content: 'Done',
        isPrimary: true,
      },
    },
  ];
  const type: { [key: string]: Object }[] = [
    { id: 'All', type: 'All' },
    { id: 'Root', type: 'Root' },
  ];
  const lines: { [key: string]: Object }[] = [
    { id: 'Horizontal', type: 'Horizontal' },
    { id: 'Vertical', type: 'Vertical' },
    { id: 'Both', type: 'Both' },
    { id: 'None', type: 'None' },
  ];

  const onChange = (sel: ChangeEventArgs): void => {
    let mode: any = sel.value?.toString();
    theGrid.filterSettings.hierarchyMode = mode;
    theGrid.clearFiltering();
  };
  const settings = () => {
    return (
      <FcSettings
        size={30}
        style={{ marginRight: 5 }}
        onClick={() => {
          setSettingsDialog(true);
        }}
      />
    );
  };
  const onChangeSettings = (args: any): void => {
    theGrid.allowPaging = args.checked;
    toggleInputs(theGrid.allowPaging, true);
  };
  const toggleInputs = (state: boolean, isPager?: boolean) => {
    if (!isPager) {
      let element: HTMLElement = document.getElementsByClassName(
        'con-prop1'
      )[0] as HTMLElement;
      element.style.display = state ? 'table-row' : 'none';
    }
    let flag: Boolean = sizemodeObj.value === 'All';
    let elem: HTMLCollectionOf<Element> =
      document.getElementsByClassName('con-prop2');
    for (let i: number = 0; i < elem.length; i++) {
      let element: HTMLElement = elem[i] as HTMLElement;
      element.style.display = state && flag ? 'table-row' : 'none';
    }
  };
  useEffect(() => {}, []);
  const changeNum = () => {
    var totalRecordCount =
      theGrid.pageSettings.totalRecordsCount === undefined
        ? 0
        : theGrid.pageSettings.totalRecordsCount;
    var pageSize = theGrid.pageSettings.pageSize;
    pageSizeObj.value =
      pageSizeObj.value > totalRecordCount
        ? totalRecordCount
        : pageSizeObj.value;
    pageSize = pageSizeObj.value;
    currentPageObj.max = Math.ceil(
      totalRecordCount === undefined ? 0 : totalRecordCount / pageSize
    );
  };
  const countChange = () => {
    pageCountObj.value = pageCountObj.value > 8 ? 8 : pageCountObj.value;
    theGrid.pageSettings.pageCount = pageCountObj.value;
  };
  const currentPageChange = () => {
    currentPageObj.value =
      currentPageObj.value > currentPageObj.max
        ? currentPageObj.max
        : currentPageObj.value;
    let pageNumber: number = currentPageObj.value;
    theGrid.goToPage(pageNumber);
  };

  const change = (args: Object): void => {
    let type: string = getObject('value', args);
    if (type === 'Root') {
      theGrid.pageSettings = { pageSizeMode: 'Root', pageSize: 2 };
    } else {
      theGrid.pageSettings = {
        pageSizeMode: 'All',
        pageSize: pageSizeObj.value,
      };
    }
    toggleInputs(type === 'All');
  };

  const changeGridlines = (args: ChangeEventArgs): void => {
    let lines: any = args.value?.toString();
    theGrid.gridLines = lines;
    theGrid.refresh();
  };
  const onChipClik = (args: any) => {
    if (args.index === 0) {
      theGrid.rowHeight = 20;
    } else if (args.index === 1) {
      theGrid.rowHeight = 40;
    } else {
      theGrid.rowHeight = 60;
    }
  };
  const onChangeFilterType = (sel: ChangeEventArgs): void => {
    let type: any = sel.value?.toString();
    theGrid.filterSettings.type = type;
    theGrid.clearFiltering();
  };
  const filterType: { [key: string]: Object }[] = [
    { text: 'Menu', value: 'Menu' },
    { text: 'Excel', value: 'Excel' },
  ];
  return (
    <div className={id}>
      <TreeGridComponent
        ref={(refGrid: TreeGridComponent) => {
          theGrid = refGrid;
        }}
        width={width}
        toolbar={
          enableTreeSettings
            ? [...toolbarOptions, { template: settings }]
            : toolbarOptions
        }
        height={height}
        filterSettings={filterSettings}
        treeColumnIndex={1}
        allowFiltering={true}
        allowPaging={enablePagination === undefined ? true : enablePagination}
        pageSettings={pageOptions}
        showColumnMenu={true}
        allowResizing={true}
        allowExcelExport={true}
        allowSorting={true}
        showColumnChooser
        dataBound={() => {
          if (theGrid) theGrid.selectRow(current_index, false);
          if (isFitInCOntent) {
            theGrid.autoFitColumns(theGrid.getColumnFieldNames());
          }
        }}
        toolbarClick={toolbarClick.bind(this)}
        gridLines='Both'
        allowReordering={true}
        rowSelected={onRowSelected?.bind(this)}
        rowDeselected={rowDeselected?.bind(this)}
        selectedRowIndex={current_index}
        contextMenuItems={contextMenuItems}
        contextMenuClick={contextMenuClick}
        created={onGridCreated}
        hasChildMapping={hasChildMapping}
        idMapping={idMapping}
        parentIdMapping={parentIdMapping}
        searchSettings={{
          fields: ['description'],
        }}
      >
        <ColumnsDirective>
          {columns.map((el) => {
            return (
              <ColumnDirective
                field={el.field}
                headerText={el.headerText?.replaceAll('_', ' ')}
                textAlign='Left'
                validationRules={el.validationRule}
                template={el.template}
                isPrimaryKey={el.isPrimary}
                width={el.width}
                editType={el.editType}
                allowEditing={el.allowEditing}
                editTemplate={el.editTemplate}
                format={el.format}
                key={el.field}
                visible={el.visible}
                clipMode={el.clipMode}
                allowFiltering={el.allowFiltering}
              />
            );
          })}
        </ColumnsDirective>
        <Inject
          services={[
            Edit,
            Toolbar,
            Filter,
            Page,
            ColumnChooser,
            ExcelExport,
            ColumnMenu,
            Resize,
            Sort,
            Reorder,
            Aggregate,
            ContextMenu,
          ]}
        />
      </TreeGridComponent>
      <DialogComponent
        animationSettings={{ delay: 1, duration: 500, effect: 'FadeZoom' }}
        visible={settingsDialog}
        header='Hierarchy Settings'
        close={() => {
          setSettingsDialog(false);
        }}
        open={() => {
          setSettingsDialog(true);
        }}
        buttons={buttonSettingsDialog}
        width={'500px'}
        isModal
        showCloseIcon
        allowDragging={true}
      >
        <div>
          <div className='col-lg-12 property-section'>
            <table
              id='property'
              title='Properties'
              className='table'
              style={{ width: '100%', color: 'white' }}
            >
              <tbody>
                <tr>
                  <td style={{ width: '20%' }}>
                    <div> Allow Paging </div>
                  </td>
                  <td style={{ width: '80%' }}>
                    <div>
                      <CheckBoxComponent
                        checked={true}
                        change={onChangeSettings}
                      ></CheckBoxComponent>
                    </div>
                  </td>
                </tr>
                <tr className='con-prop1'>
                  <td style={{ width: '20%' }}>
                    <div> Page Size Mode </div>
                  </td>
                  <td style={{ width: '80%' }}>
                    <div id='dropdown'>
                      <DropDownListComponent
                        id='asset-hierarchy-type'
                        change={change}
                        dataSource={type}
                        fields={{ text: 'type', value: 'id' }}
                        value='All'
                        ref={(dropdown: DropDownListComponent) =>
                          (sizemodeObj = dropdown)
                        }
                      />
                    </div>
                  </td>
                </tr>
                <tr className='con-prop2'>
                  <td style={{ width: '20%' }}>
                    <div> Page Size </div>
                  </td>
                  <td style={{ width: '80%' }}>
                    <div id='numericbox'>
                      <NumericTextBoxComponent
                        id='pagesize'
                        format='##'
                        min={1}
                        max={200}
                        value={12}
                        ref={(numeric: NumericTextBoxComponent) =>
                          (pageSizeObj = numeric)
                        }
                        change={changeNum}
                      ></NumericTextBoxComponent>
                    </div>
                  </td>
                </tr>
                <tr className='con-prop2'>
                  <td style={{ width: '20%' }}>
                    <div> Page Count </div>
                  </td>
                  <td style={{ width: '80%' }}>
                    <div id='numericbox'>
                      <NumericTextBoxComponent
                        id='pagecount'
                        format='##'
                        min={1}
                        max={4}
                        value={2}
                        ref={(numeric: NumericTextBoxComponent) =>
                          (pageCountObj = numeric)
                        }
                        change={countChange}
                      ></NumericTextBoxComponent>
                    </div>
                  </td>
                </tr>
                <tr className='con-prop2'>
                  <td style={{ width: '20%' }}>
                    <div> Current Page </div>
                  </td>
                  <td style={{ width: '80%' }}>
                    <div id='numericbox'>
                      <NumericTextBoxComponent
                        id='currentpage'
                        format='##'
                        min={1}
                        max={17}
                        value={1}
                        ref={(numeric: NumericTextBoxComponent) =>
                          (currentPageObj = numeric)
                        }
                        change={currentPageChange}
                      ></NumericTextBoxComponent>
                    </div>
                  </td>
                </tr>
                <tr className='con-prop2'>
                  <td style={{ width: '20%' }}>
                    <div> Current Page </div>
                  </td>
                  <td style={{ width: '80%' }}>
                    <div id='numericbox'>
                      <DropDownListComponent
                        id='asset-hier-parent'
                        change={onChange}
                        dataSource={[
                          { text: 'Parent', value: 'Parent' },
                          { text: 'Child', value: 'Child' },
                          { text: 'Both', value: 'Both' },
                          { text: 'None', value: 'None' },
                        ]}
                        value='Parent'
                        placeholder='Choose filter type'
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '20%' }}>
                    <div>Grid Lines</div>
                  </td>
                  <td style={{ width: '80%' }}>
                    <div>
                      <DropDownListComponent
                        width='115px'
                        id='asset-hier-vertical'
                        change={changeGridlines}
                        dataSource={lines}
                        fields={{ text: 'type', value: 'id' }}
                        value='Vertical'
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '20%' }}>
                    <div> Filter Type </div>
                  </td>
                  <td style={{ width: '80%' }}>
                    <div>
                      <DropDownListComponent
                        id='asset-hier-menu'
                        change={onChangeFilterType}
                        dataSource={filterType}
                        value='Menu'
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '100%' }}>
                    <ChipListComponent
                      id='chip-choice'
                      selection='Single'
                      cssClass='e-outline'
                      selectedChips={[1]}
                      click={onChipClik}
                    >
                      <ChipsDirective>
                        <ChipDirective
                          text='Small'
                          leadingIconCss='e-medium-ico'
                        ></ChipDirective>
                        <ChipDirective
                          text='Medium'
                          leadingIconCss='e-small-icon'
                        ></ChipDirective>
                        <ChipDirective
                          text='Big'
                          leadingIconCss='chip-choice'
                        ></ChipDirective>
                      </ChipsDirective>
                    </ChipListComponent>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </DialogComponent>
    </div>
  );
};

export default GlobalHierGrid;
